// components/Layout.js
import { Outlet } from "react-router-dom";
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
  return (
    <div className="bg-gray-950 text-gray-600 flex flex-col min-h-screen">
      <Header />
      <div className="container mx-auto px-0 mt-16 flex-grow">
      <main className="flex-1 mt-2 mb-14 px-0 overflow-y-auto">
        <Outlet /> 
      </main>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
